import { motion } from "framer-motion";
import { skillGroups } from "@/data/portfolio";
import { Section } from "@/components/Section";

export const Skills = () => (
  <Section id="skills" index="05" title="Skills">
    <div data-testid="skills-taxonomy" className="grid gap-px border border-white/10 bg-white/10 md:grid-cols-2 lg:grid-cols-3">
      {skillGroups.map((g, i) => (
        <motion.div
          key={g.name}
          data-testid={`skill-group-${g.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-30px" }}
          transition={{ duration: 0.5, delay: i * 0.05 }}
          className="group bg-[#050505] p-8 transition-colors duration-500 hover:bg-[#0A0A0A]"
        >
          <h3 className="mb-5 flex items-baseline gap-3 font-mono text-xs uppercase tracking-[0.25em] text-cyan-400">
            <span className="text-zinc-600">{String(i + 1).padStart(2, "0")}</span>
            {g.name}
          </h3>
          <div className="flex flex-wrap gap-1.5">
            {g.skills.map((s) => (
              <span
                key={s}
                className="border border-white/10 px-2.5 py-1 font-mono text-[11px] text-zinc-400 transition-colors duration-300 hover:border-cyan-400/60 hover:text-cyan-300"
              >
                {s}
              </span>
            ))}
          </div>
        </motion.div>
      ))}
    </div>
  </Section>
);
